<template>
  <div>
    <div ref="paypal"></div>
  </div>
</template>

<script>

import consts from '@/consts'
import {mapActions} from 'vuex'

export default {
  name: 'PaypalPayment',
  props: {
    track: {
      default: null
    },
    value: {
      default: null
    },
    ppPlans: {
      default: null
    },
    refCode: {
      default: null
    },
    voucher: {
      default: null
    }
  },
  data () {
    return {
      loaded: false,
      paidFor: false,
      product: {
        price: 0,
        description: ''
      },
      subscriptionPaymentURL: consts.PP_SUBSCRIPTION_PAYMENT_URL,
      trackPaymentURL: consts.PP_TRACK_PAYMENT_URL
    }
  },
  created () {

  },
  mounted () {
    const script = document.createElement('script')
    if (this.track && this.value) {
      script.src = this.trackPaymentURL
      script.addEventListener('load', this.buyTrack)
    } else if (this.ppPlans) {
      script.src = this.subscriptionPaymentURL
      script.addEventListener('load', this.newSubscription)
    }
    document.body.appendChild(script)
  },
  methods: {
    ...mapActions('user', [
      'subscribeByPaypal',
      'paypalCaptureOrder'
    ]),
    ...mapActions('track', [
      'getBuyLink'
    ]),
    newSubscription () {
      let that = this
      that.loaded = true
      let ppPlan
      if (this.voucher && this.voucher.months === 3) {
        ppPlan = that.ppPlans.find(plan => {
          return plan.id === 'P-0MJ6500297088250TMZCNHPY'
        })
      } else {
        ppPlan = that.ppPlans[0]
      }
      window.paypal
        .Buttons({
          createSubscription (data, actions) {
            return actions.subscription.create({
              plan_id: ppPlan.id
            })
          },
          async onApprove (data, actions) {
            var subscriptionPlan = ppPlan
            that.paidFor = true
            var amountPayed = null
            var tokenData = null
            if (data) {
              tokenData = data.facilitatorAccessToken
            }

            let subsData = {
              gateway: 'paypal',
              details: {data, subscriptionPlan},
              amount: amountPayed,
              token: tokenData,
              refCode: that.refCode,
              voucherCode: that.voucher.code
            }
            that.subscribeByPaypal(subsData)

            setTimeout(() => {
              that.$router.push({path: '/'})
            }, 5000)
            that.$modal.hide('payment-modal')
          },
          onError (err) {
            console.log(err)
            that.$toasted.show(err, {type: 'error'})
            that.$modal.hide('payment-modal')
          }
        })
        .render(that.$refs.paypal)
    },
    buyTrack () {
      let that = this
      that.loaded = true
      window.paypal
        .Buttons({
          createOrder (data, actions) {
            return actions.order.create({
              purchase_units: [
                {
                  description: 'Track: ' + that.track.title + ', ' + 'Artist_code: ' + that.track.id_artist,
                  amount: {
                    currency_code: 'USD',
                    value: that.value,
                    breakdown: {
                      item_total: {
                        currency_code: 'USD',
                        value: that.value
                      }
                    }
                  },
                  items: [
                    {
                      name: 'Track: ' + that.track.title + ', ' + 'Artist_code: ' + that.track.id_artist,
                      unit_amount: {
                        currency_code: 'USD',
                        value: that.value
                      },
                      quantity: 1
                    }
                  ]
                }
              ]
            })
          },
          async onApprove (data, actions) {
            that.paypalCaptureOrder(data.orderID).then(response => {
              if (response.status === 'COMPLETED') {
                that.paidFor = true
                that.getBuyLink({
                  value: that.value,
                  track: that.track,
                  gateway: 'paypal',
                  currency: 'USD',
                  description: response
                })
                that.$modal.hide('payment-modal')
                that.$toasted.show(that.$t('tracks.buyTrack.downloadMessage'), {type: 'success'})
              } else {
                that.$modal.hide('payment-modal')
                that.$toasted.show('The payment is pending approval.', {type: 'success'})
              }
            })
          },
          onError (err) {
            console.log(err)
            that.$toasted.show(err, {type: 'error'})
            that.$modal.hide('payment-modal')
          }
        })
        .render(that.$refs.paypal)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/modals/PaypalPayment.vue